export default __webpack_public_path__ + "static/housing_assistance-a3b5840e079ead1bb6bee265c6c7272d.png";